import * as types from '../types/storeSettingsTypes';
import { USE_API } from '../../config/env';
import { storeSettingsService } from '../../services/storeSettingsService';
import { DEFAULT_SETTINGS } from '../reducers/storeSettingsReducer';

function normalizeMeta(data) {
  const mv = data?.metaVerification;
  return {
    google: mv && mv.google != null ? String(mv.google).trim() : '',
    bing: mv && mv.bing != null ? String(mv.bing).trim() : '',
    yandex: mv && mv.yandex != null ? String(mv.yandex).trim() : '',
    pinterest: mv && mv.pinterest != null ? String(mv.pinterest).trim() : '',
    facebook: mv && mv.facebook != null ? String(mv.facebook).trim() : '',
    custom: Array.isArray(mv?.custom) ? mv.custom : [],
  };
}

function mergeSettings(data) {
  if (!data) return DEFAULT_SETTINGS;
  const sp =
    data.shippingPricing && typeof data.shippingPricing === 'object' ? data.shippingPricing : {};
  return {
    ...DEFAULT_SETTINGS,
    name: data.name || DEFAULT_SETTINGS.name,
    description: data.description || DEFAULT_SETTINGS.description,
    address: data.address || DEFAULT_SETTINGS.address,
    phone: data.phone || DEFAULT_SETTINGS.phone,
    email: data.email || DEFAULT_SETTINGS.email,
    shippingPricing: {
      ...DEFAULT_SETTINGS.shippingPricing,
      ...sp,
    },
    metaVerification: normalizeMeta(data),
  };
}

export const fetchStoreSettings = () => async (dispatch) => {
  if (!USE_API) return;
  dispatch({ type: types.FETCH_STORE_SETTINGS_REQUEST });
  try {
    const data = await storeSettingsService.getSettings();
    dispatch({
      type: types.FETCH_STORE_SETTINGS_SUCCESS,
      payload: mergeSettings(data),
    });
  } catch (e) {
    const msg = e?.response?.data?.message || e?.message || 'Failed to load store settings';
    dispatch({ type: types.FETCH_STORE_SETTINGS_FAILURE, payload: msg });
  }
};
